// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'jfriou',
    name: 'whufih',
    phone: 'qmfrojh'
  },
  {
    contactKey: 'yutrvs',
    name: 'mgjyhgf',
    phone: 'gyftgfd'
  },
  {
    contactKey: 'gfyrtyrt',
    name: 'sdfwef',
    phone: 'sdgrthr'
  },
  {
    contactKey: 'rtgdfwerf',
    name: 'gntyjng',
    phone: 'fghjrtyrty'
  },
  {
    contactKey: 'fjhrth',
    name: 'fgnfhn',
    phone: 'dfgerg'
  },
  {
    contactKey: 'ktwsbpns',
    name: 'heacifnnqm',
    phone: 'wqfxflsq'
  },
  {
    contactKey: 'cmuyn',
    name: 'oqgbly',
    phone: 'pqvdlci'
  },
  {
    contactKey: 'nkmhlgfmtion',
    name: 'zupjrnlxpf',
    phone: 'kczhemogw'
  },
  {
    contactKey: 'vzymdoitcc',
    name: 'ublibky',
    phone: 'czdgm'
  },
  {
    contactKey: 'laowijme',
    name: 'elbgzglnnu',
    phone: 'irhslzhs'
  },
  {
    contactKey: 'gqivk',
    name: 'rhqouc',
    phone: 'nybwro'
  },
  {
    contactKey: 'xuywmlss',
    name: 'bfgoxcg',
    phone: 'sdznra'
  },
  {
    contactKey: 'loemd',
    name: 'uwybckjsd',
    phone: 'puwjbcjks'
  },
  {
    contactKey: 'fmbrplfpngm',
    name: 'pxgfdxfapw',
    phone: 'iuxhsje'
  },
  {
    contactKey: 'wftvekq',
    name: 'ufrngdn',
    phone: 'imsqgq'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'gherwsdfs',
  'tyyreds',
  'jtyheewr',
  'fsdjfwesd',
  'vvgxrfgoq',
  'ojjhi',
  'mxfsmrpumt',
  'pfdcs',
  'mzdbmbbexnke',
  'omfjb',
  'mjgwkww',
  'ajcbhdjs',
  'dsgepwnkke',
  'mhndkjuj'
]
export { contactsList, scoreFuncNameList }
